import { translate } from "@/i18n/i18n";
import { FC } from "react";

export const Ready: FC = () => {
    return (
        <div className="relative w-[100%] h-[100%] px-3 flex flex-col justify-center items-center text-2xl">
            <div className="z-10">
                Donation { translate("DONO_TRAIN_IS_READY") }
            </div>
        </div>
    );
}